import { isPageSupported, Routes } from 'constants/pages';
import { DropdownMenuItem, menuItemFactory } from 'layouts/AppPageTemplate/utils/menus';
import { Region } from 'services/clients/regions';
import { User } from 'types/User';
import { checkForPermission, Permission } from 'utils/permissions';
import { checkSegmentation } from 'utils/permissions/segmentation';

export const getLandingMenu: (
  region: Region,
  permissions: Permission[],
  user: User | null
) => DropdownMenuItem[] = (region, permissions, user) => {
  let entries: DropdownMenuItem[] = [
    {
      type: 'nested',
      title: 'Port Intelligence',
      children: [
        menuItemFactory(Routes.RegionalEmptyAppointments, {
          title: 'Find Empty Appointments',
        }),
        menuItemFactory(Routes.RegionalGateSchedule),
        menuItemFactory(Routes.VesselSchedule),
        menuItemFactory(Routes.RegionalEmptyReturnLocations),
      ],
    } as DropdownMenuItem,
    {
      type: 'nested',
      title: 'Per Diem Documentation',
      children: [
        menuItemFactory(Routes.RegionalPerDiemArchive),
        menuItemFactory(Routes.RegionalTerminalScreenshots),
      ],
    },
    {
      type: 'nested',
      title: 'Container Tracking',
      children: [
        menuItemFactory(Routes.ContainerTracking, { title: 'Track Your Containers' }),
        menuItemFactory(Routes.ShipmentsActive, {
          title: checkForPermission([Permission.TrackNTrace], permissions)
            ? "Shipper's Watchlist"
            : 'Watchlist',
        }),
        menuItemFactory(Routes.ShipmentsDashboard),
      ],
    },
  ];

  entries = entries
    .map((e) => ({
      ...e,
      children: e.children.filter((item) => {
        if (!isPageSupported(item.page, region)) {
          return false;
        }

        // Always show the menu item if the user belongs to its segment
        if (checkSegmentation(user?.company?.segmentation, item.page.segmentation)) {
          return true;
        }

        const requirements = item.page.requiredPermissions;
        if (requirements && !checkForPermission(requirements, permissions)) {
          return false;
        }

        return true;
      }),
    }))
    .filter((item) => item.children.length);

  return entries;
};
